module.exports = __webpack_public_path__ + "static/media/jo.a9b7b75b.svg";